export const AGENT_AUTO_LOGOUT_CLICKSTREAM = {
  LH_AUTO_LOGOUT_TRIGGERED: {
    name: 'LH_AUTO_LOGOUT_TRIGGERED',
    description: 'When the user is auto logged out'
  }
};
